const restHost = "https://rbxos-cs.dev.e-fork.net",
  restHostBackend = "https://rbxos-cs.dev.e-fork.net",
  fileHost = "https://rbxos-cs.dev.e-fork.net",
  graphQlEndpoint = "/graphql",
  drupalFormat = "YYYY-MM-DDTHH:mm:ss",
  self = "https://rbxos.dev.e-fork.net",
  appPort = 3000,
  redisHost = "master.rbf-ssr-cache.lj6guv.euw1.cache.amazonaws.com",
  redisPort = 6379,
  redisEnabled = false;

module.exports = {
  restHost,
  restHostBackend,
  fileHost,
  graphQlEndpoint,
  self,
  appPort,
  drupalFormat,
  redisHost,
  redisPort,
  redisEnabled
};
